import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './SubscribeForm.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    address: '',
    zipcode:'',
  });
const generateCaptcha = () => {
  const a = Math.floor(Math.random() * 10);
  const b = Math.floor(Math.random() * 10);
  return { question: `${a} + ${b}`, answer: a + b };
};

const [captcha, setCaptcha] = useState(generateCaptcha());
const [captchaInput, setCaptchaInput] = useState('');
const [captchaError, setCaptchaError] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
const nameRegex = /^[a-zA-Z\s]+$/;
const emailRegex = /^\S+@\S+\.\S+$/;
const zipRegex = /^\d{6}$|^\d{6}-\d{5}$/;
  const validate = () => {
  const newErrors = {};

  if (!formData.firstname.trim()) {
    newErrors.firstname = 'First name is required.';
  } else if (!nameRegex.test(formData.firstname)) {
    newErrors.firstname = 'First name can only contain letters and spaces.';
  }

  if (!formData.lastname.trim()) {
    newErrors.lastname = 'Last name is required.';
  } else if (!nameRegex.test(formData.lastname)) {
    newErrors.lastname = 'Last name can only contain letters and spaces.';
  }

  if (!formData.email) {
    newErrors.email = 'Email is required.';
  } else if (!emailRegex.test(formData.email)) {
    newErrors.email = 'Please enter a valid email address.';
  }
  if (!formData.zipcode) {
    newErrors.zipcode = 'Zipcode is required.';
  } else if (!zipRegex.test(formData.zipcode)) {
    newErrors.zipcode = 'Please enter a valid zipcode address.';
  }
if (!formData.address.trim()) {
  newErrors.address = 'Message is required.';
} else if (formData.address.length < 10) {
  newErrors.address = 'Message must be at least 10 characters.';
}
if (parseInt(captchaInput) !== captcha.answer) {
  setCaptchaError('Incorrect CAPTCHA answer.');
  return false;
}
  if (!formData.address.trim()) newErrors.address = 'Suggessions is required.';
  if (!formData.agree) newErrors.agree = 'You must agree to continue.';
 

  // Optional: If you have a ZIP code field
  // if (formData.zip && !zipRegex.test(formData.zip)) {
  //   newErrors.zip = 'ZIP code must be 6 digits or 6 digits + hyphen + 5 digits.';
  // }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);

    try {
      const response = await fetch('https://webvexo.com/csub_web_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Subscribed!',
          text: 'Thanks for Submitting your Valuable Suggessions.',
        });
        setFormData({
          firstname: '',
          lastname: '',
          email: '',
          address: '',
          zipcode:'',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Submission failed',
          text: 'Please try again later.',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Network error',
        text: 'Check your connection and try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container margin-top mb-5 mt-5">
        <div className="row d-flex justify-content-center mb-5">
            
                <p className="text-center mb-5 fw-bold fs-1 color">Contact</p>
                <div className="col-md-8 p-5">
                  <p className="fs-7 text-center"><i class="bi bi-geo-alt"></i> &nbsp;&nbsp;33 Washington Square W, New York, NY 10011, USA</p>
                    <form onSubmit={handleSubmit} className='subscribe-form'>
                        <div className='row'>
                            {[
                            { name: 'firstname', label: 'First Name' },
                            { name: 'lastname', label: 'Last Name' },
                            { name: 'email', label: 'Email', type: 'email' },
                            ].map(({ name, label, type = 'text' }) => (
                                <div className="col-md-4 mb-2" key={name}>
                                    <input type={type} name={name} value={formData[name]} onChange={handleChange}
                                    className={`form-control ${errors[name] ? 'input-error' : ''}`}
                                    placeholder={label}
                                    />
                                    {errors[name] && <small className="text-danger">{errors[name]}</small>}
                                </div>
                            ))}
                        </div>
                        <div className="row mb-2">
                            <div className='col-md-12'>
                                <textarea
                                    name="address"
                                    rows="4"
                                    value={formData.address}
                                    onChange={handleChange}
                                    className={`form-control ${errors.address ? 'input-error' : ''}`}
                                    placeholder="Write your Suggessions..."
                                ></textarea>
                                {errors.address && <small className="text-danger">{errors.address}</small>}
                            </div>
                        </div>
                        <div className="form-group mb-2">
                            <label className="mb-1 fs-5 fw-bold">What is {captcha.question}?</label>
                            <input
                                type="text"
                                name="captcha"
                                value={captchaInput}
                                onChange={(e) => {
                                setCaptchaInput(e.target.value);
                                setCaptchaError('');
                                }}
                                className={`form-control ${captchaError ? 'input-error' : ''}`}
                                placeholder="Enter answer"
                            />
                            {captchaError && <small className="text-danger">{captchaError}</small>}
                        </div>
                        
                        <button type="submit" className="insuba-btn text-center w-50 p-2 fs-5 mt-3" disabled={isLoading}>
                        {isLoading ? (
                            <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" />
                            Submitting...
                            </>
                        ) : (
                            'Submit'
                        )}
                        </button>
                    </form>
                 
            </div>
        </div>
    </div>
  );
};

export default Contact;
